
/*
 * Copyright (c) 2026. Orion Analytics.
 * All Rights Reserved.
 */

import React, { useEffect, useState } from "react";

import {
    fetchMarketSructure
} from "../../api";

import MarketWidgetNav
from "./MarketWidgetNav";

import MarketSubNav
from "./MarketSubNav";

import OIBuildUpDashboard
from "./OIBuildUpDashboard";

import OIHeatmap
from "./OIHeatmap";

import RollingSpreadChart
from "./RollingSpreadChart";

import OptionsSignalBubbleChart
from "./OptionsSignalBubbleChart";

// import ClientPositioning
// from "./ClientPositioning";

import PCRDashboard
from "./PCRDashboard";

// import MaxPainChart
// from "./MaxPainChart";

import CommentaryCard
from "./CommentaryCard";
import Chartgrid from "../chartgrid";
import FuturesPositioning from "./FuturesPositioning";
import MetricPills from "../common/MetricPills";
import MetricAssistant from "../common/MetricAssistant";
import MetricHelp from "../common/MetricHelp";

export default function MarketStructure({
        activeWidget,
    }) {

    const widgets = [
        "Open Interest",
        "PCR Analysis",
        "Options Activity",
        "Futures Positioning"
    ];

    // const [activeWidget, setActiveWidget] =
    //     useState("Open Interest");

    const [data, setData] =
        useState(null);

    useEffect(() => {

        fetchMarketSructure()
            .then(res => {

                console.log(
                    "DERIVATIVES DATA",
                    res
                );

                setData(res);

            })
            .catch(err => {

                console.error(
                    "Failed loading derivatives",
                    err
                );

            });

    }, []);

    if (!data) {

        return (

            <div
                className="
                    flex
                    items-center
                    justify-center
                    h-96
                    text-slate-400
                "
            >
                Loading Derivatives...
            </div>

        );

    }

    return (

        <div
            className="
                flex
                gap-6
                h-full
            "
        >

            {/* LEFT NAVIGATION */}

            {/*<MarketWidgetNav*/}
            {/*    widgets={widgets}*/}
            {/*    activeWidget={activeWidget}*/}
            {/*    setActiveWidget={*/}
            {/*        setActiveWidget*/}
            {/*    }*/}
            {/*/>*/}

            {/* MAIN CONTENT */}
                <MetricAssistant
                    title="Derivatives Guide"
                    context="derivatives"
                />
                <div
                className="
                    flex-1
                    min-w-0
                "
            >

                {/*<MarketSubNav*/}
                {/*    title="Derivatives Market"*/}
                {/*    subtitle="Options, Futures & Positioning Intelligence"*/}
                {/*/>*/}

                {/* ===========================================
                    OPEN INTEREST
                ============================================ */}

                {activeWidget ===
                    "Open Interest" && (

                    <div
                        className="
                            space-y-6
                        "
                    >
                        <OIBuildUpDashboard
                            futuresData={
                                data.futures_df
                            }
                            optionsData={
                                data.options_df
                            }
                        />

                        <OIHeatmap
                            optionData={
                                data.options_df
                            }
                        />

                        <CommentaryCard
                            futuresData={
                                data.futures_df
                            }
                            optionsData={
                                data.options_df
                            }
                        />

                    </div>

                )}

                {/* ===========================================
                    PCR ANALYSIS
                ============================================ */}

                {activeWidget ===
                    "PCR Analysis" && (

                    <div
                        className="
                            space-y-6
                        "
                    >

                        <PCRDashboard
                            data={data}
                        />

                    </div>

                )}

                {/* ===========================================
                    OPTIONS ACTIVITY
                ============================================ */}

                {activeWidget ===
                    "Options Activity" && (

                    <div
                        className="
                            space-y-6
                        "
                    >

                        <OptionsSignalBubbleChart
                            signalData={
                                data.options_df
                            }
                        />

        <Chartgrid rows={1} cols={1} symbols={['NIFTY']} charttype={['oi']}/>


                    </div>

                )}

                {/* ===========================================
                    FUTURES POSITIONING
                ============================================ */}

                {activeWidget ===
                    "Futures Positioning" && (

                    <div
                        className="
                            space-y-6
                        "
                    >

                        <FuturesPositioning
                            trendData={
                                data.clients_trend
                            }
                            latestData={
                                data.clients_latest
                            }
                        />

                        <RollingSpreadChart
                            spreads={
                                data.rolling_spreads
                            }
                        />

                        {/*<ClientPositioning*/}
                        {/*    trendData={*/}
                        {/*        data.clients_trend*/}
                        {/*    }*/}
                        {/*    latestData={*/}
                        {/*        data.clients_latest*/}
                        {/*    }*/}
                        {/*/>*/}

                    </div>

                )}

            </div>

        </div>

    );

}
